import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './ContactUs.css';
// In src/index.js or src/App.js
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import images directly for better handling by build tools like Create React App
import Contact1 from '../../Assets/conct1.png';
import Contact2 from '../../Assets/conct2.png';
import Contact3 from '../../Assets/conct3.png';
import Contact4 from '../../Assets/conct4.png'; // Assuming this is another image for the slider

const ContactUs = () => {
    // Basic state for form fields (can be expanded for more complex handling)
    const [formData, setFormData] = React.useState({
        firstName: '',
        lastName: '',
        contact: '',
        email: '',
        message: '',
        appointmentDate: '', // Added back for potential future use
        appointmentTime: '', // Added back for potential future use
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically send formData to a server
        console.log('Appointment Request Form Data:', formData);
        window.open('mailto:tharoonavee@gmail.com?subject=Appointment Request&body=' + encodeURIComponent(JSON.stringify(formData)), '_blank');
        alert('Form submitted! (Check console for data)');
        // You might want to clear the form after submission
        setFormData({
            firstName: '',
            lastName: '',
            contact: '',
            email: '',
            message: '',
            appointmentDate: '',
            appointmentTime: '',
        });
    };

    return (
        <div className="contact-us-page">
            {/* Top Section */}
            <div className="top-contact-section">
                <Container>
                    <Row className="align-items-center mb-4 header-row">
                        <h1 className="main-heading">Let's work together.</h1>
                    </Row>

                    <div className="image-contact-info-grid-container">
                        <div className="image-slider-container">
                            {/* Adjusted the class name to target it correctly in CSS */}
                            <div className="slider-wrapper">
                                {/* Use imported images */}
                                <img src={Contact1} alt="Contact Us Background 1" />
                                <img src={Contact2} alt="Contact Us Background 2" />
                                <img src={Contact3} alt="Contact Us Background 3" />
                                <img src={Contact4} alt="Contact Us Background 4" />
                            </div>
                        </div>

                        <div className="contact-info-block">
                            <div className="contact-item">
                                <i className="bi bi-envelope"></i>
                                <div>
                                    <strong> Email </strong>
                                    <span>info@vtasassociates.com</span>
                                </div>
                            </div>
                            <div className="contact-item">
                                <i className="bi bi-telephone"></i>
                                <div>
                                    <strong> Contact </strong>
                                    <span>  +94 76 837 6087,&nbsp;&nbsp;&nbsp;
                                        +94 77 786 4451,&nbsp;&nbsp;&nbsp;
                                        +94 76 624 7888</span>
                                </div>
                            </div>
                            <div className="contact-item head-office">
                                <i className="bi bi-geo-alt"></i>
                                <div>
                                    <strong>Head Office</strong>
                                    <span>No.70/12/B, &nbsp; D.S.Senanayaka Mawatha, &nbsp; Colombo 08.</span>
                                </div>
                            </div>

                            <div className="branch-offices-grid-container">
                                <div className="contact-item branch-office">
                                    <i className="bi bi-geo-alt"></i>
                                    <div>
                                        <strong>Branch Office</strong>
                                        <span>Abhimani Building, Madagama Road, Madampe.</span>
                                    </div>
                                </div>
                                <div className="contact-item branch-office">
                                    <i className="bi bi-geo-alt"></i>
                                    <div>
                                        <strong>Branch Office</strong>
                                        <span>No.643/1/C, Bandarawatta, Kadawatha.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            {/* Appointment Request Form Section */}
            <div className="form-section" style={{ backgroundColor: 'rgb(2, 54, 70)' }}>
                <Container className="form-container">
                    <h2 className="form-title">Appointment Request Form</h2>
                    <p className="form-subtitle">Let us know how we can help you!</p>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col xs={12} md={6} className="mb-3 mb-md-0">
                                <Form.Group controlId="formFirstName">
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="First Name"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label className="d-none d-md-block">&nbsp;</Form.Label> {/* For alignment */}
                                    <Form.Control
                                        type="text"
                                        placeholder="Last Name"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3" controlId="formContact">
                            <Form.Label> Contact Number </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Contact Number"
                                name="contact"
                                value={formData.contact}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="example@example.com"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formMessage">
                            <Form.Label> Message </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Let us know how we can help you!"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <div className='text-center'>
                            <Button variant="primary" type="submit" className="mt-3">
                                Submit Request
                            </Button>
                        </div>
                    </Form>
                </Container>
            </div>
        </div>
    );
};

export default ContactUs;